import { env } from '@/config/env';
import type { Locale } from '@/i18n/translations';
import { requestJson } from './transport';

export async function publicRequest<T>(
  path: string,
  locale: Locale,
  options: { signal?: AbortSignal | undefined } = {},
): Promise<T> {
  // Public content must stay anonymous, including for donors with staff permissions.
  return (await requestJson(`${env.apiBaseUrl}${path}`, {
    credentials: 'omit',
    headers: { 'X-App-Language': locale },
    ...(options.signal ? { signal: options.signal } : {}),
  })) as T;
}
